module.exports = {
	"ha": "iha",
	"id": 5.7,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by HSDA, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 88.63636363636364,
						"dataLabels": {
							"enabled": true,
							"format": "39"
						}
					},
					{
						"y": 56.81818181818182,
						"dataLabels": {
							"enabled": true,
							"format": "25"
						}
					},
					{
						"y": 52.27272727272727,
						"dataLabels": {
							"enabled": true,
							"format": "23"
						}
					},
					{
						"y": 47.72727272727273,
						"dataLabels": {
							"enabled": true,
							"format": "21"
						}
					},
					{
						"y": 40.909090909090914,
						"dataLabels": {
							"enabled": true,
							"format": "18"
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "64"
						}
					},
					{
						"y": 81.25,
						"dataLabels": {
							"enabled": true,
							"format": "52"
						}
					},
					{
						"y": 78.125,
						"dataLabels": {
							"enabled": true,
							"format": "50"
						}
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": true,
							"format": "44"
						}
					},
					{
						"y": 57.8125,
						"dataLabels": {
							"enabled": true,
							"format": "37"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.97687861271676,
						"dataLabels": {
							"enabled": true,
							"format": "339"
						}
					},
					{
						"y": 82.65895953757226,
						"dataLabels": {
							"enabled": true,
							"format": "286"
						}
					},
					{
						"y": 80.05780346820809,
						"dataLabels": {
							"enabled": true,
							"format": "277"
						}
					},
					{
						"y": 74.27745664739885,
						"dataLabels": {
							"enabled": true,
							"format": "257"
						}
					},
					{
						"y": 54.6242774566474,
						"dataLabels": {
							"enabled": true,
							"format": "189"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.5,
						"dataLabels": {
							"enabled": true,
							"format": "195"
						}
					},
					{
						"y": 79,
						"dataLabels": {
							"enabled": true,
							"format": "158"
						}
					},
					{
						"y": 72.5,
						"dataLabels": {
							"enabled": true,
							"format": "145"
						}
					},
					{
						"y": 66.5,
						"dataLabels": {
							"enabled": true,
							"format": "133"
						}
					},
					{
						"y": 51.5,
						"dataLabels": {
							"enabled": true,
							"format": "103"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -11.363636363636365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.89743589743589,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.75,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.909090909090907,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.023121387283233,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.634218289085544,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1468531468531458,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.220216606498198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.45914396887159,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.500000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.974358974358974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.227848101265822,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.275862068965523,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.55639097744361,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "East Kootenay<br>n=44"
			},
			{
				"x": 9,
				"text": "Kootenay Boundary<br>n=64"
			},
			{
				"x": 15,
				"text": "Okanagan<br>n=346"
			},
			{
				"x": 21,
				"text": "Thompson Cariboo Shuswap<br>n=200"
			}
		],
		"dataTable": {
			"East Kootenay": [
				44,
				39,
				25,
				23,
				21,
				18
			],
			"Kootenay Boundary": [
				64,
				64,
				52,
				50,
				44,
				37
			],
			"Okanagan": [
				346,
				339,
				286,
				277,
				257,
				189
			],
			"Thompson Cariboo Shuswap": [
				200,
				195,
				158,
				145,
				133,
				103
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_7.json
// module id = 239
// module chunks = 0